<ng-container>
  <form
    nz-form
    [formGroup]="updatePhoneNumberForm"
    *ngIf="updatePhoneNumberForm"
  >
    <nz-form-item>
      <nz-form-control>
        <nz-radio-group
          formControlName="updateType"
          (ngModelChange)="onUpdateTypeChange($event)"
        >
          <nz-card [nzTitle]="selectPhoneRadioTpl">
            <div nz-row>
              <div nz-col nzSpan="10">
                <nz-form-item>
                  <label>
                    {{
                      UPDATE_PHONE_NUMBER_FORM_PREFIX + "SELECT_AREA_CODE"
                        | translate
                    }}
                  </label>
                  <nz-form-control [nzErrorTip]="areaCodeSelectErrorTpl">
                    <nz-select
                      nzAllowClear="true"
                      formControlName="areaCode"
                      (ngModelChange)="onUpdateAreaCode($event)"
                      [nzPlaceHolder]="
                        UPDATE_PHONE_NUMBER_FORM_PREFIX + 'SELECT_AREA_CODE'
                          | translate
                      "
                    >
                      <nz-option
                        *ngFor="let areaCodeInfo of areaCodesInfo"
                        [nzValue]="areaCodeInfo.areaCode"
                        [nzLabel]="areaCodeInfo.areaCode"
                      ></nz-option>
                    </nz-select>
                    <ng-template #areaCodeSelectErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        {{ "FORM.ERR.REQUIRED_AREA_CODE" | translate }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="13" nzOffset="1">
                <nz-form-item>
                  <nz-form-control [nzErrorTip]="phoneNumberSelectErrorTpl">
                    <label>
                      {{ "FORM.LABEL.PHONE" | translate }}
                    </label>
                    <nz-select
                      nzAllowClear="true"
                      formControlName="phoneNumberSelect"
                      [nzPlaceHolder]="
                        UPDATE_PHONE_NUMBER_FORM_PREFIX + 'SELECT_PHONE_NUMBER'
                          | translate
                      "
                    >
                      <nz-option
                        *ngFor="let phoneNumber of phoneNumbers"
                        [nzValue]="phoneNumber"
                        [nzLabel]="phoneNumber"
                      ></nz-option>
                    </nz-select>
                    <ng-template #phoneNumberSelectErrorTpl let-control>
                      <ng-container *ngIf="control.hasError('required')">
                        {{ "FORM.ERR.REQUIRED_PHONE_NUMBER" | translate }}
                      </ng-container>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </nz-card>
          <nz-card [nzTitle]="inputPhoneRadioTpl">
            <app-phone-input
              [formGroup]="updatePhoneNumberForm"
              controlName="phoneNumberInput"
              [onlyCountries]="[countryISO.Mexico]"
              [selectedCountryISO]="countryISO.Mexico"
              [separateDialCode]="true"
            ></app-phone-input>
          </nz-card>

          <ng-template #selectPhoneRadioTpl>
            <label nz-radio [nzValue]="updateType.SELECT">
              {{
                UPDATE_PHONE_NUMBER_FORM_PREFIX + "SELECT_PHONE_NUMBER"
                  | translate
              }}
            </label>
          </ng-template>

          <ng-template #inputPhoneRadioTpl>
            <label nz-radio [nzValue]="updateType.INPUT">
              {{
                UPDATE_PHONE_NUMBER_FORM_PREFIX + "TYPE_PHONE_NUMBER"
                  | translate
              }}
            </label>
          </ng-template>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-container>
